var _path, _path2, _path3, _path4, _rect, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.6894 41.7046C41.5262 41.3238 41.0853 41.1475 40.7046 41.3106C40.3238 41.4738 40.1475 41.9147 40.3106 42.2954L41.6894 41.7046ZM69.6644 20.152C69.4722 19.7851 69.0189 19.6434 68.652 19.8356L62.6726 22.9677C62.3057 23.1599 62.1641 23.6131 62.3563 23.9801C62.5485 24.347 63.0017 24.4886 63.3686 24.2964L68.6836 21.5124L71.4677 26.8274C71.6599 27.1943 72.1131 27.3359 72.48 27.1437C72.847 26.9515 72.9886 26.4983 72.7964 26.1314L69.6644 20.152ZM57.9745 49.7899L57.2731 50.0553L57.9745 49.7899ZM46.3511 50.0775L45.6435 49.8289L46.3511 50.0775ZM44.4885 50.14L43.7992 50.4354L44.4885 50.14ZM52.9701 36.5638L52.2686 36.8292L52.9701 36.5638ZM50.3837 36.3376L45.6435 49.8289L47.0587 50.3261L51.7989 36.8348L50.3837 36.3376ZM45.1779 49.8445L41.6894 41.7046L40.3106 42.2954L43.7992 50.4354L45.1779 49.8445ZM68.2841 20.2763L59.1484 49.5106L60.5801 49.958L69.7158 20.7237L68.2841 20.2763ZM58.676 49.5245L53.6715 36.2984L52.2686 36.8292L57.2731 50.0553L58.676 49.5245ZM59.1484 49.5106C59.0776 49.7373 58.7601 49.7467 58.676 49.5245L57.2731 50.0553C57.8616 51.6108 60.0841 51.5454 60.5801 49.958L59.1484 49.5106ZM45.6435 49.8289C45.568 50.0439 45.2677 50.054 45.1779 49.8445L43.7992 50.4354C44.4276 51.9017 46.5299 51.8313 47.0587 50.3261L45.6435 49.8289ZM51.7989 36.8348C51.8762 36.6148 52.1861 36.6111 52.2686 36.8292L53.6715 36.2984C53.0938 34.7715 50.9249 34.7974 50.3837 36.3376L51.7989 36.8348Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 70L55 70",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 58L37 70",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45 58L45 70",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 10,
    width: 72.4,
    height: 48,
    rx: 3,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13 38.5C13 44.8513 18.1487 50 24.5 50C30.8513 50 36 44.8513 36 38.5C36 32.1487 30.8513 27 24.5 27C18.1487 27 13 32.1487 13 38.5Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 61L16 47",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeo);
export default __webpack_public_path__ + "static/media/seo.22591c500b8b94656140841eefb9be9a.svg";
export { ForwardRef as ReactComponent };